// Product.jsx
import React, { useContext, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CartContext } from '../cart/ContextProvider';
import { useNavigate, useParams } from 'react-router';
import axios from 'axios';
import './Product.css';
import RelatedProducts from './RelatedProducts';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import BreadCrum from '../BreadCrum/BreadCrum';
import Loader from '../common/Loader';
import CustomLoader from 'react-spinners/PuffLoader';
import { Button } from 'bootstrap';


function Product() {
  const { cartItems, addCartItem, initialLoading } = useContext(CartContext);
  const location = useLocation();
  const [product, setProduct] = useState(null);
  const [addedToCart, setAddedToCart] = useState(false);
  const [loading, setLoading] = useState(true); // Added loading state
  const [cartLoading, setCartLoading] = useState(false)
  const navigate = useNavigate();
  const params = useParams();

  useEffect(() => {
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
    }, 1500)
  }, [])

  useEffect(() => {

    const fetchProduct = async () => {

      try {
        const response = await axios.get(`https://jackpotbackend.vercel.app/product/${params.id}`);
        setProduct(response.data);
      } catch (error) {
        console.error('Error fetching product details:', error);
      } finally {
        // setLoading(false); // Set loading to false when fetching ends
      }
    };

    fetchProduct();
  }, [location, params.id]);


  useEffect(() => {

    window.scrollTo({ top: 0, behavior: 'instant' });
    if (product && product.id) {
      const existingItem = cartItems.find((cartItem) => cartItem.id === product.id);
      setAddedToCart(!!existingItem);
    }
  }, [cartItems, product]);

  async function handleCartClick(event) {
    event.stopPropagation();
    setCartLoading(true)
    const response = await addCartItem(product, 1);
    if (!!response) {
      setAddedToCart(true);

    }

    setCartLoading(false)
  }

  return (
    <div className='product-div-main'>
      {loading || initialLoading ? (
        <div className="loading-container">
          <Loader />
        </div>
      ) : (
        <div>
          {product && <BreadCrum product={product} />}
          <div className="productDiv">
            <div className="product-left">
              {product ? (
                <>
                  <div className="product-img-list">
                    <img src={product.image} alt={product.name} />
                    <img src={product.image} alt={product.name} />
                    <img src={product.image} alt={product.name} />
                    <img src={product.image} alt={product.name} />
                  </div>
                  <div className="product-img">
                    <img className="product-img-main" src={product.image} alt={product.name} />
                  </div>
                </>
              ) : (
                <p>Loading image...</p>
              )}
            </div>

            <div className="product-right">
              {product ? (
                <div>
                  <div className='nameNdPrice'>
                    <div className='title'>
                      <h1>{product.name}</h1>
                      <p>{product.brand}</p>
                    </div>
                    <div className="product-right-price">
                      <p>
                        <CurrencyRupeeIcon className="rupee-icon" />
                        {product.price}
                      </p>
                    </div>
                  </div>
                  <hr className='hrAbovePrice' />
                  <div className="product-right-price">
                    <p>
                      <CurrencyRupeeIcon className="rupee-icon" />
                      {product.price}
                    </p>
                  </div>

                  <hr className='hrBelowPrice' />

                  <div className="product-right-size">
                    <h1>Select Size</h1>
                    <div className="product-right-sizes">
                      <div>S</div>
                      <div>M</div>
                      <div>L</div>
                      <div>XL</div>
                      <div>XXL</div>
                    </div>
                  </div>

                  <div className="product-right-material">
                    <p>Material: </p>
                    <h4>{product.material}</h4>
                  </div>
                </div>
              ) : (
                <p>Loading...</p>
              )}

              {addedToCart ? (
                <button onClick={() => {
                  navigate(`/cart`)
                }} className="btnStyle">
                  GO TO CART
                </button>
              ) : cartLoading ? (
                <button className="btnStyle" >
                  <div className='loader'>
                    <CustomLoader color="#fff" size={24} speedMultiplier={2} />
                  </div>
                </button>
              ) : (<>
                <Link className="btnStyle" onClick={handleCartClick}>
                  ADD TO CART
                </Link>

              </>

              )}
            </div>
          </div>

          {product && <RelatedProducts product={product} />}
        </div>
      )}
     
    </div>
  );
}

export default Product;
